import { Navigate, useParams } from 'react-router-dom';
import { useUserContext } from '../../contexts/UserContext';
import { UserModuleProvider } from '../../contexts/UserModuleContext';
import { BackButton, PageHeader } from '../ui';
import { SkillsetClassificationEvaluations } from './SkillsetClassificationEvaluations';
import '../../css/SkillsetSetupLibraryPage.css';

const GRADE_USER_SKILLSETS_LIST_PATH = '/user-skillsets?tab=user-proficiencies';

const GradeUserSkillsetsPageInner = () => {
    const { userId } = useParams<{ userId: string }>();
    const { allCompanyUsers } = useUserContext();

    if (!userId) {
        return <Navigate to={GRADE_USER_SKILLSETS_LIST_PATH} replace />;
    }

    const user = allCompanyUsers.find((companyUser) => companyUser.id === userId);
    const userName = user?.name?.trim() || user?.email || 'User';

    return (
        <div className="page-container sslp-page">
            <BackButton to={GRADE_USER_SKILLSETS_LIST_PATH} buttonText="Back to User Skillsets" />
            <PageHeader title={userName} signalLine="Grade User Skillsets" />
            <SkillsetClassificationEvaluations userId={userId} readOnly={false} />
        </div>
    );
};

export const GradeUserSkillsetsPage = () => (
    <UserModuleProvider>
        <GradeUserSkillsetsPageInner />
    </UserModuleProvider>
);
